
<div class="space-y-6">
 @if(hasAccess()) {
  <div class="flex flex-col lg:flex-row gap-6">
    <!-- Sidebar -->
    <div class="lg:w-1/4 xl:w-1/5 flex-shrink-0">
      <div class="bg-white p-4 rounded-md shadow-sm">
        <h2 class="text-lg font-bold text-gray-800 flex items-center gap-2">
            <i class="fa-solid fa-chart-pie text-emerald-600"></i> {{ 'backOffice.sidebar.reports' | translate }}
        </h2>
        <nav class="space-y-1 mt-4">
          <p class="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2 pl-3">Clinic</p>
          <button (click)="switchReport('clinical-stats')" [class]="'w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2 ' + (reportType() === 'clinical-stats' ? 'bg-emerald-100 text-emerald-800' : 'hover:bg-gray-100 text-gray-700')">
            <i class="fa-solid fa-user-doctor w-5 text-center"></i> {{ 'backOffice.reports.sidebar.clinicalStats' | translate }}
          </button>
          
          <button (click)="switchReport('referral-stats')" [class]="'w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2 ' + (reportType() === 'referral-stats' ? 'bg-blue-100 text-blue-800' : 'hover:bg-gray-100 text-gray-700')">
            <i class="fa-solid fa-handshake w-5 text-center"></i> {{ 'backOffice.reports.sidebar.referralStats' | translate }}
          </button>

           <p class="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2 mt-4 pl-3">Staff</p>
           <button (click)="switchReport('shifts')" [class]="'w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2 ' + (reportType() === 'shifts' ? 'bg-emerald-100 text-emerald-800' : 'hover:bg-gray-100 text-gray-700')">
            <i class="fa-solid fa-clock-rotate-left w-5 text-center"></i> {{ 'backOffice.reports.sidebar.shifts' | translate }}
          </button>
        </nav>
        
        <div class="mt-6 p-4 bg-amber-50 rounded text-xs text-amber-800 border border-amber-200">
            <i class="fa-solid fa-circle-info mr-1"></i> Sales reports are hidden in Clinic mode.
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="flex-grow min-w-0">
      <!-- Header & Filters -->
      <div class="bg-white p-4 rounded-md shadow-sm mb-6">
        <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div class="flex items-center gap-2 bg-slate-100 p-1 rounded-lg border">
                <button (click)="setDateRange('today')" [class]="'px-3 py-1.5 rounded-md text-sm font-semibold ' + (activePreset() === 'today' ? 'bg-emerald-600 text-white' : 'text-gray-600 hover:bg-gray-200')">{{ 'backOffice.dashboard.filters.today' | translate }}</button>
                <button (click)="setDateRange('7d')" [class]="'px-3 py-1.5 rounded-md text-sm font-semibold ' + (activePreset() === '7d' ? 'bg-emerald-600 text-white' : 'text-gray-600 hover:bg-gray-200')">{{ 'backOffice.dashboard.filters.last7days' | translate }}</button>
                <button (click)="setDateRange('30d')" [class]="'px-3 py-1.5 rounded-md text-sm font-semibold ' + (activePreset() === '30d' ? 'bg-emerald-600 text-white' : 'text-gray-600 hover:bg-gray-200')">{{ 'backOffice.dashboard.filters.last30days' | translate }}</button>
            </div>
            
             <button (click)="exportToCsv()" class="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors flex items-center gap-2 justify-center">
                <i class="fa-solid fa-file-csv"></i>
                <span>{{ 'backOffice.reports.exportCsv' | translate }}</span>
            </button>
        </div>
      </div>
      
       <!-- Content Area -->
      <div class="bg-white p-4 sm:p-6 rounded-md shadow-sm">
         @switch (loadingState()) {
            @case ('loading') {
              <div class="text-center py-20 text-gray-500"><i class="fa-solid fa-spinner animate-spin text-4xl mb-4"></i><p>{{ 'backOffice.reports.loading' | translate }}</p></div>
            }
            @case ('error') {
              <div class="bg-red-100 text-red-800 p-6 rounded-md"><p class="font-bold">Error</p><pre>{{ loadingError() }}</pre></div>
            }
            @case ('loaded') {
                @switch(reportType()) {
                    @case('clinical-stats') {
                        <div>
                            <h3 class="text-lg font-bold text-gray-800 mb-4">{{ 'backOffice.reports.clinical.symptoms' | translate }}</h3>
                            <div class="space-y-4 mb-8">
                                @for(stat of symptomStats(); track stat.symptom) {
                                    <div>
                                        <div class="flex justify-between items-center text-sm mb-1">
                                            <span class="font-medium text-gray-700">{{ stat.symptom }}</span>
                                            <span class="text-gray-500">{{ stat.count }} Cases ({{ stat.percentage }}%)</span>
                                        </div>
                                        <div class="w-full bg-gray-200 rounded-full h-2.5">
                                            <div class="bg-blue-600 h-2.5 rounded-full" [style.width.%]="stat.percentage"></div>
                                        </div>
                                    </div>
                                }
                            </div>

                            <h3 class="text-lg font-bold text-gray-800 mb-4 border-t pt-6">{{ 'backOffice.reports.clinical.doctorPerformance' | translate }}</h3>
                            <div class="overflow-x-auto">
                                <table class="min-w-full">
                                    <thead>
                                        <tr class="bg-slate-50">
                                            <th class="p-3 text-left font-semibold text-gray-600">{{ 'common.name' | translate }}</th>
                                            <th class="p-3 text-right font-semibold text-gray-600">Patient Count</th>
                                            <th class="p-3 text-right font-semibold text-gray-600">Prescriptions Issued</th>
                                        </tr>
                                    </thead>
                                    <tbody class="divide-y">
                                        @for(doc of doctorStats(); track doc.doctorName) {
                                            <tr>
                                                <td class="p-3 font-medium text-gray-800">{{ doc.doctorName }}</td>
                                                <td class="p-3 text-right">{{ doc.patientCount }}</td>
                                                <td class="p-3 text-right">{{ doc.prescriptionsIssued }}</td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                    
                    @case('referral-stats') {
                         <div>
                            <h3 class="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                                <i class="fa-solid fa-network-wired text-blue-600"></i> {{ 'backOffice.reports.referral.title' | translate }}
                            </h3>

                            <!-- Stats Cards -->
                            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                                <div class="bg-blue-50 border border-blue-200 p-4 rounded-xl">
                                    <p class="text-xs font-bold text-blue-500 uppercase tracking-wide">{{ 'backOffice.reports.referral.totalRequests' | translate }}</p>
                                    <p class="text-3xl font-bold text-blue-800">{{ totalReferrals() | number }}</p>
                                </div>
                                <div class="bg-emerald-50 border border-emerald-200 p-4 rounded-xl">
                                    <p class="text-xs font-bold text-emerald-500 uppercase tracking-wide">{{ 'backOffice.reports.referral.totalApproved' | translate }}</p>
                                    <p class="text-3xl font-bold text-emerald-800">{{ totalApprovedReferrals() | number }}</p>
                                </div>
                                <div class="bg-purple-50 border border-purple-200 p-4 rounded-xl">
                                    <p class="text-xs font-bold text-purple-500 uppercase tracking-wide">{{ 'backOffice.reports.referral.topSender' | translate }}</p>
                                    <p class="text-xl font-bold text-purple-800 truncate" [title]="topReferringPartner()">{{ topReferringPartner() }}</p>
                                </div>
                            </div>

                            <div class="overflow-x-auto rounded-lg border border-gray-200">
                                <table class="min-w-full divide-y divide-gray-200">
                                    <thead class="bg-gray-50">
                                        <tr>
                                            <th class="p-3 text-left text-xs font-bold text-gray-500 uppercase">{{ 'backOffice.reports.referral.table.sender' | translate }}</th>
                                            <th class="p-3 text-center text-xs font-bold text-gray-500 uppercase">{{ 'backOffice.reports.referral.table.total' | translate }}</th>
                                            <th class="p-3 text-center text-xs font-bold text-gray-500 uppercase">{{ 'backOffice.reports.referral.table.approved' | translate }}</th>
                                            <th class="p-3 text-center text-xs font-bold text-gray-500 uppercase">{{ 'backOffice.reports.referral.table.rejected' | translate }}</th>
                                            <th class="p-3 text-center text-xs font-bold text-gray-500 uppercase">{{ 'backOffice.reports.referral.table.pending' | translate }}</th>
                                            <th class="p-3 text-center text-xs font-bold text-gray-500 uppercase">{{ 'backOffice.reports.referral.table.rate' | translate }}</th>
                                            <th class="p-3 text-right text-xs font-bold text-gray-500 uppercase">{{ 'backOffice.reports.referral.table.lastActive' | translate }}</th>
                                        </tr>
                                    </thead>
                                    <tbody class="bg-white divide-y divide-gray-200">
                                        @for(stat of referralStats(); track stat.partnerId) {
                                            <tr class="hover:bg-slate-50 transition-colors">
                                                <td class="p-3">
                                                    <div class="font-bold text-gray-800">{{ stat.partnerName }}</div>
                                                    <div class="text-xs text-gray-400 font-mono">ID: {{ stat.partnerId.substring(0,8) }}...</div>
                                                </td>
                                                <td class="p-3 text-center font-bold">{{ stat.totalRequests }}</td>
                                                <td class="p-3 text-center text-emerald-600 font-bold bg-emerald-50/50">{{ stat.approvedCount }}</td>
                                                <td class="p-3 text-center text-red-500">{{ stat.rejectedCount }}</td>
                                                <td class="p-3 text-center text-orange-500">{{ stat.pendingCount }}</td>
                                                <td class="p-3 text-center text-sm font-bold text-gray-600">
                                                    {{ stat.totalRequests > 0 ? (stat.approvedCount / stat.totalRequests | percent:'1.0-0') : '0%' }}
                                                </td>
                                                <td class="p-3 text-right text-xs text-gray-500">
                                                    {{ stat.lastActivity | date:'d MMM, HH:mm' }}
                                                </td>
                                            </tr>
                                        } @empty {
                                            <tr>
                                                <td colspan="7" class="p-8 text-center text-gray-500">
                                                    {{ 'backOffice.reports.empty' | translate }}
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }

                    @case('shifts') {
                        <div class="overflow-x-auto"><table class="min-w-full"><thead><tr><th class="p-2 text-left text-xs font-medium text-gray-500 uppercase">{{ 'backOffice.reports.headers.cashier' | translate }}</th><th class="p-2 text-left text-xs font-medium text-gray-500 uppercase">{{ 'backOffice.reports.headers.openedAt' | translate }}</th><th class="p-2 text-left text-xs font-medium text-gray-500 uppercase">{{ 'backOffice.reports.headers.closedAt' | translate }}</th></tr></thead><tbody class="divide-y">
                            @for(item of shifts(); track item.id) { <tr><td class="p-2 font-medium">{{ item.cashierName }}</td><td class="p-2">{{ item.openedAt | date:'d MMM, HH:mm' }}</td><td class="p-2">{{ item.closedAt | date:'d MMM, HH:mm' }}</td></tr> }
                            @empty { <tr><td colspan="3" class="text-center p-8 text-gray-500">{{ 'backOffice.reports.empty' | translate }}</td></tr> }
                        </tbody></table></div>
                    }
                }
            }
         }
      </div>
    </div>
  </div>
 } @else {
    <div class="bg-white p-8 rounded-md shadow-sm text-center">
        <i class="fa-solid fa-lock text-4xl text-yellow-500 mb-4"></i>
        <h2 class="text-2xl font-bold text-gray-800">Reporting is a Pro Feature</h2>
        <p class="text-gray-600 mt-2 max-w-md mx-auto">This feature provides detailed reports on your sales, products, and employees. Please upgrade your plan to enable this functionality.</p>
        <a routerLink="/admin/billing" class="mt-6 inline-block bg-emerald-600 text-white px-6 py-3 rounded-md hover:bg-emerald-700 font-semibold">
            Upgrade to Pro
        </a>
    </div>
 }
</div>
